import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';
import {
  IPAD,
  LayoutColumnsDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  QUIZ_CHOICE,
  TEXT,
  LayoutListDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const SocialMedia5iPad: Translator = sequence => {
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Email':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'left',
            height: { _: 'auto', lg: '100%' }
          },
          items: [
            {
              type: IPAD,
              id: item.id,
              values: {
                from: 'username@email.com',
                subject: 'Marco’s medical record',
                title: item.title || "You've got mail!",
                body: item.body,
                logo: item?.pictures ? item.pictures[0].mediaUrl : null
              },
              items: []
            }
          ]
        } as LayoutListDefinition);
        break;
      case 'Question':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'left',
            height: { _: 'auto', lg: '100%' }
          },
          items: [
            {
              id: item.id,
              type: LAYOUT_LIST,
              values: { align: 'left' },
              items: [
                {
                  type: TEXT,
                  id: `${item.id}_subtitle`,
                  items: [],
                  values: {
                    value: item.subtitle || 'QUIZ',
                    variant: 'sub_heading',
                    icon: item.icon
                  }
                },
                {
                  type: TEXT,
                  id: `${item.id}_title`,
                  items: [],
                  values: {
                    value: item.title,
                    variant: 'heading1'
                  }
                },
                {
                  type: TEXT,
                  id: `${item.id}_body`,
                  items: [],
                  values: {
                    value: item.body
                  }
                },
                {
                  type: QUIZ_CHOICE,
                  id: '1',
                  values: {
                    variant: item.items && item.items.length > 2 ? 'list' : '',
                    title: item?.title?.includes('?')
                      ? item.title
                      : item?.body?.includes('?')
                      ? item.body
                      : '',
                    length: item?.items?.length,
                    multiSelect: item?.items?.filter(
                      item => item.correct === true
                    ).length
                  },
                  items: AnswerButtonHelper({
                    group: item.id,
                    items: item.items,
                    llamaSurvey: item.llamaSurvey,
                    question: item.title || ''
                  })
                }
              ]
            }
          ]
        } as LayoutListDefinition);
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
